import { useEffect, useState } from 'react';

export const useOverflowing = (ref: React.RefObject<HTMLDivElement>) => {
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (!ref.current) return;

            const { scrollWidth, offsetWidth } = ref.current;

            setIsOverflowing(scrollWidth > offsetWidth);
        };

        const timeoutId = setTimeout(checkOverflow, 0);

        window.addEventListener('resize', checkOverflow);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', checkOverflow);
        };
    }, [ref]);

    return isOverflowing;
};
